import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '../Container';
import { HeroContent, Image, Media, Wrapper } from './wrapper';

interface IHeroImage {
  src: string;
  srcSet?: string;
  srcLtSm?: string;
  alt?: string;
}

export interface IHero {
  children?: React.ReactNode;
  image?: IHeroImage;
  tone?: 'light';
  imagePosition?: 'bottom';
  underHeader?: boolean;
  heightAuto?: boolean;
  contentMaxWidth?: boolean;
}

const Hero = ({
  children,
  image,
  tone,
  imagePosition,
  underHeader,
  heightAuto,
  contentMaxWidth,
}: IHero) => {
  const { t } = useTranslation(['other']);

  return (
    <Wrapper $tone={tone} $underHeader={underHeader} $heightAuto={heightAuto}>
      {image && (
        <Media>
          <picture>
            {image.srcLtSm && <source media="(max-width: 599px)" srcSet={image.srcLtSm} />}
            <Image
              src={image.src}
              srcSet={image.srcSet}
              alt={image.alt ? image.alt : t('heroImageAltFallback', { ns: 'other' })}
              $imagePosition={imagePosition}
            />
          </picture>
        </Media>
      )}
      {children && (
        <Container>
          <HeroContent $limitWidth={contentMaxWidth}>{children}</HeroContent>
        </Container>
      )}
    </Wrapper>
  );
};

export default Hero;
